module.exports = __webpack_public_path__ + "img/jobsmedia.68d8ffed.svg";